
import Vue from "vue";
import Loader from "@/components/Multiloader.vue";
import Table, { Column } from "@/components/Table.vue";

export default Vue.extend({
  name: "Analysen",
  components: {
    Loader,
    Table
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      countMessst: 0,
      anaDates: [] as any[],
      selectedDate: "",
      // countMessstView: {
      //   name:
      //     "MESSSTELLEN_GRUNDWASSER_MESSSTELLENQUANTITATIV_COUNTMESSSTELLENQUALIGRUNDWASSER",
      // },
      analysedatenView: {
        name: "messstellen_grundwasser_messwertequalitativ_anadaten",
        condition: ["messst_nr=number:" + this.id]
      },
      tableColumns: [
        {
          text: "Parameter",
          key: "param_nr"
        },
        {
          text: "Bezeichnung",
          key: "param_name"
        },
        {
          text: "Status",
          key: "status_bez",
          custom: el =>
            el.status_bez == null || el.status_bez == "normal"
              ? "-"
              : el.status_bez
        },
        {
          text: "Wert",
          key: "wert"
        },
        {
          text: "Einheit",
          key: "einheit"
        }
      ] as Column[]
    };
  },
  computed: {
    messwerteView(): any {
      return {
        name: "messstellen_grundwasser_messwertequalitativ_messwerte",
        condition: [
          "ana_datum=date:" + this.selectedDate,
          "messst_nr=" + this.id
        ]
      };
    }
  },
  methods: {
    loadedAnaData(data: Array<any>) {
      this.anaDates = data.map((obj: any) => obj.anadatum);
      this.selectedDate = this.anaDates[0];
    }
  }
});
